<template>
    <div>
        <kgr-dropdown
            display="title"
            :options="filteredDrafts"
            :label="tLabel"
            :value="value"
            :loading="loading"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import Dropdown from './Dropdown.vue';
import LetterDraftSetRepository from '../../../../js/repository/LetterDraftSetRepository';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            required: true,
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            drafts: [],
        };
    },
    computed: {
        tLabel() {
            return this.hideLabel ? null : this.$t('draftSet');
        },
        filteredDrafts() {
            return this.drafts.filter((draft) => this.excludedIds.indexOf(draft.id) === -1);
        },
    },
    created() {
        LetterDraftSetRepository
            .findAll(this.clubId)
            .then((data) => {
                this.drafts = data;
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
